"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const complex_plugin_1 = require("complex-plugin");
const icons_vue_1 = require("@ant-design/icons-vue");
const user_1 = __importDefault(require("@/data/user"));
const require_1 = require("@/require");
const TabView_vue_1 = __importDefault(require("./TabView.vue"));
const complex_utils_1 = require("complex-utils");
exports.default = (0, vue_1.defineComponent)({
    name: 'HeaderView',
    components: {
        TabView: TabView_vue_1.default,
        PoweroffOutlined: icons_vue_1.PoweroffOutlined,
        QuestionCircleOutlined: icons_vue_1.QuestionCircleOutlined
    },
    data() {
        return {
            user: user_1.default
        };
    },
    methods: {
        logout() {
            complex_plugin_1.notice.confirm('确认注销登录吗?', '注销', act => {
                if (act === 'ok') {
                    require_1.refreshLogin.$triggerLife('logout');
                    window.location.reload();
                }
            });
        },
        toOperationManual() {
            (0, complex_utils_1.openWindow)('https://doc.wuzheng.com.cn/doc-wiki#/page/share/home?space=12853025372417036683', '_blank');
        }
    },
});
